import { action, makeObservable, observable } from "mobx";

class BaseMapStore {
    center?: google.maps.LatLngLiteral | undefined;
    isLoading = false;
    map?: google.maps.Map;
    zoom: number;

    constructor(center?: google.maps.LatLngLiteral, zoom = 15) {
        this.center = center;
        this.zoom = zoom;

        makeObservable(this, {
            isLoading: observable,
            center: observable,
            zoom: observable,
            updateCenter: action,
            updateIsLoading: action,
            updateMap: action,
            updateZoom: action,
        });
    }


    updateCenter = (value?: google.maps.LatLngLiteral) => {
        this.center = value;

        if (this.map && value) {
            this.map.setCenter(value);
        }
    }

    updateIsLoading(value: boolean) {
        this.isLoading = value;
    }

    updateMap(value: google.maps.Map) {
        this.map = value;
    }

    updateZoom(value: number) {
        this.zoom = value;

        if (this.map) {
            this.map.setZoom(value);
        }
    }
}

export default BaseMapStore;